(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('WarningsDashboard', WarningsDashboard);

    WarningsDashboard.$inject = ['$resource'];

    function WarningsDashboard($resource) {
        var resourceUrl = 'api/warnings-dashboard';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'search': {method: 'POST', isArray: true},
            'topName': {
                url: 'api/warnings-dashboard/topName',
                method: 'POST',
                isArray: true},
            'topObjects': {
                url: 'api/warnings-dashboard/topObject',
                method: 'POST',
                isArray: true}
        });
    }




})();
